import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useUpgradeRecommendationEnabled } from './useUpgradeRecommendationEnabled';
export const useRecommendationRevealEnabled = () => {
  const {
    isEnabled: isAiEnabled
  } = useAiRecommendationEnabled();
  const {
    isEligible,
    variant
  } = useUpgradeRecommendationEnabled();
  const isUpgradeReveal = !isAiEnabled && isEligible && variant === 'B';
  return {
    isEnabled: isAiEnabled || isUpgradeReveal,
    isUpgradeReveal
  };
};
//# sourceMappingURL=useRecommendationRevealEnabled.js.map